import ErrorHandlingForm from "../../../components/formValidation/ErrorHandlingForm";
import { useState } from "react";
import { validateRequired } from "../../../components/formValidation/validators";
import { Stack, Typography } from "@mui/material";
import CustomTextField from "../../../components/formValidation/CustomTextField";
import CustomCountrySelect from "../../../components/formValidation/CustomCountrySelect";

const PersonBillingData = ({ reference, data, setData }) => {
    const [errors, setErrors] = useState({
        billing_name: false,
        billing_country: false,
        billing_postal_code: false,
        billing_city: false,
        billing_address: false,
    });

    const validators = {
        billing_name: [validateRequired],
        billing_country: [validateRequired],
        billing_postal_code: [validateRequired],
        billing_city: [validateRequired],
        billing_address: [validateRequired],
    };

    return (
        <ErrorHandlingForm
            reference={reference}
            data={data}
            setData={setData}
            errors={errors}
            setErrors={setErrors}
            validators={validators}
        >
            <Stack spacing={1}>
                <Typography id="billing-name-label" variant="caption" color='primary.main'>
                    Számlázási név*
                </Typography>
                <CustomTextField
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_name"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-name-label",
                        "aria-required": "true",
                    }}
                />

                <Typography id="billing-country-label" variant="caption" color='primary.main'>
                    Ország*
                </Typography>
                <CustomCountrySelect
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_country"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-country-label",
                        "aria-required": "true",
                    }}
                />

                <Stack direction={{xs: 'column', md: 'row'}} width='100%' spacing={2}>
                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-postal-code-label" variant="caption" color='primary.main'>
                            Irányítószám*
                        </Typography>
                        <CustomTextField
                            data={data}
                            setData={setData}
                            errors={errors}
                            setErrors={setErrors}
                            validators={validators}
                            name="billing_postal_code"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-postal-code-label",
                                "aria-required": "true",
                            }}
                        />
                    </Stack>

                    <Stack width='100%' spacing={1}>
                        <Typography id="billing-city-label" variant="caption" color='primary.main'>
                            Város*
                        </Typography>
                        <CustomTextField
                            data={data}
                            setData={setData}
                            errors={errors}
                            setErrors={setErrors}
                            validators={validators}
                            name="billing_city"
                            variant="standard"
                            inputProps={{
                                "aria-labelledby": "billing-city-label",
                                "aria-required": "true",
                            }}
                        />
                    </Stack>
                </Stack>

                <Typography id="billing-address-label" variant="caption" color='primary.main'>
                    Cím*
                </Typography>
                <CustomTextField
                    data={data}
                    setData={setData}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="billing_address"
                    variant="standard"
                    inputProps={{
                        "aria-labelledby": "billing-address-label",
                        "aria-required": "true",
                    }}
                />
            </Stack>
        </ErrorHandlingForm>
    );
};

export default PersonBillingData;
